module.exports = __webpack_public_path__ + "static/media/14UNEP4.ff41edc8.jpg";